module.exports = __webpack_public_path__ + "static/media/buttons.f82a749b.png";